import React from 'react';

const LoadingSpinner = ({ fullPage = true }) => {
  if (fullPage) {
    return (
      <div className="flex h-screen bg-[#F8F5EF] dark:bg-[#171112]">
        {/* Don't show Sidebar during loading to avoid z-index conflicts */}
        <div className="flex-1 flex items-center justify-center">
          <LoadingIcon />
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#F8F5EF] dark:bg-[#171112]">
      <LoadingIcon />
    </div>
  );
};

const LoadingIcon = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <div className="relative flex items-center justify-center w-24 h-24">
        {/* soft ambient glow */}
        <div className="absolute inset-0 rounded-full bg-[#9A313B]/10 dark:bg-[#DEBE82]/10 blur-2xl" />

        {/* rotating progress ring */}
        <svg
          className="absolute inset-0 h-full w-full tp-spin text-[#9A313B] dark:text-[#DEBE82]"
          viewBox="0 0 100 100"
          fill="none"
          aria-hidden="true"
        >
          <circle cx="50" cy="50" r="45" stroke="currentColor" strokeOpacity="0.12" strokeWidth="3" />
          <circle
            cx="50"
            cy="50"
            r="45"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray="70 220"
          />
        </svg>

        {/* brand mark */}
        <img
          src="/brand/bike-icon.png"
          alt=""
          className="relative w-12 h-12 object-contain tp-bike-ride dark:hidden"
        />
        <img
          src="/brand/bike-icon-gold.png"
          alt=""
          className="relative w-12 h-12 object-contain tp-bike-ride hidden dark:block"
        />
      </div>

      <div className="mt-6 text-[10px] font-semibold tracking-[0.4em] uppercase text-[#52262D]/50 dark:text-[#DEBE82]/60">
        Walks Through Time
      </div>

      <div className="mt-3 flex items-center gap-1.5" aria-hidden="true">
        <span className="tp-dot h-1.5 w-1.5 rounded-full bg-[#9A313B]/50 dark:bg-[#DEBE82]/60" style={{ animationDelay: '0ms' }} />
        <span className="tp-dot h-1.5 w-1.5 rounded-full bg-[#9A313B]/50 dark:bg-[#DEBE82]/60" style={{ animationDelay: '160ms' }} />
        <span className="tp-dot h-1.5 w-1.5 rounded-full bg-[#9A313B]/50 dark:bg-[#DEBE82]/60" style={{ animationDelay: '320ms' }} />
      </div>

      <style>{`
        @keyframes tpBikeRide {
          0%, 100% { transform: translateY(0) rotate(-2deg); }
          50% { transform: translateY(-4px) rotate(2deg); }
        }
        .tp-bike-ride { animation: tpBikeRide 1.4s ease-in-out infinite; }
        @keyframes tpSpin { to { transform: rotate(360deg); } }
        .tp-spin { animation: tpSpin 1.1s linear infinite; transform-origin: 50% 50%; }
        @keyframes tpDot {
          0%, 100% { opacity: 0.25; transform: translateY(0); }
          50% { opacity: 1; transform: translateY(-3px); }
        }
        .tp-dot { animation: tpDot 1s ease-in-out infinite; }
        @media (prefers-reduced-motion: reduce) {
          .tp-bike-ride, .tp-spin, .tp-dot { animation: none; }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;
export { LoadingIcon };
